
// ─── UTILITY: ek hi jagah se shadow root milega ───────────────
function waitForShadow(cb) {
  const sc = document.querySelector("shadow-dom-container");
  if (sc && sc.shadowRoot) { cb(sc.shadowRoot); return; }

  const obs = new MutationObserver(function () {
    const sc2 = document.querySelector("shadow-dom-container");
    if (sc2 && sc2.shadowRoot) {
      obs.disconnect();
      cb(sc2.shadowRoot);
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
}

// ─── UTILITY: debounce helper ─────────────────────────────────
function debounce(fn, delay) {
  let timer;
  return function () { clearTimeout(timer); timer = setTimeout(fn, delay); };
}


// ─── 1. REVIEW BUTTON LOAD MORE ICON ─────────────────────────
document.addEventListener('DOMContentLoaded', function () {

  function injectIcons() {
    document.querySelectorAll('.jdgm-paginate__load-more').forEach(function (btn) {
      btn.childNodes.forEach(function (node) {
        if (node.nodeType === 3) node.textContent = 'View More';
      });
      if (btn.querySelector('.custom-arrow-icon')) return;

      const icon = document.createElement('span');
      icon.className = 'custom-arrow-icon';
      icon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
          <rect x="0.5" y="-0.5" width="19" height="19" rx="9.5"
            transform="matrix(1 0 0 -1 0.5 19.2014)" stroke="#808080"/>
          <path d="M7 8.7431L10.5 11.6598L14 8.7431" stroke="#808080" stroke-linecap="round"/>
        </svg>`;
      btn.appendChild(icon);
    });
  }

  function updateIconRotation(btn) {
    const icon = btn.querySelector('.custom-arrow-icon');
    if (!icon) return;
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    icon.classList.toggle('rotate-down', isExpanded);
    icon.classList.toggle('rotate-up', !isExpanded);
  }

  injectIcons();
  document.querySelectorAll('.jdgm-paginate__load-more').forEach(updateIconRotation);

  new MutationObserver(debounce(function () {
    injectIcons();
    document.querySelectorAll('.jdgm-paginate__load-more').forEach(updateIconRotation);
  }, 100)).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.jdgm-paginate__load-more');
    if (btn) updateIconRotation(btn);
  });
});


// ─── 2. JUDGEME REVIEW COMMENT COUNT ─────────────────────────
(function () {
  function formatWithCommas(str) {
    const num = parseInt(str.replace(/,/g, ''), 10);
    if (isNaN(num)) return str;
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function fixReviewNumbers() {
    const badge = document.querySelector('.jdgm-prev-badge__text');
    if (badge && badge.textContent) {
      const fixed = badge.textContent.replace(/\((\d+)\s*reviews?\)/gi, function (_, num) {
        return '(' + formatWithCommas(num) + ' reviews)';
      });
      if (fixed !== badge.textContent) badge.textContent = fixed;
    }

    const count = document.getElementById('jdgm-review-count');
    if (count && count.textContent) {
      const fixed = formatWithCommas(count.textContent);
      if (fixed !== count.textContent) count.textContent = fixed;
    }
  }

  fixReviewNumbers();
  new MutationObserver(debounce(fixReviewNumbers, 100)).observe(document.body, { childList: true, subtree: true });
})();


// ─── 3. SHADOW DOM — sab functions ek jagah se ───────────────
waitForShadow(function (sr) {

  // ── 3a. Your Cart text
  function fixCartText() {
    const t = sr.querySelector(".side-cart-header p");
    if (t && t.innerText !== "Your Cart") t.innerText = "Your Cart";
  }

  // ── 3b. Progress bar icons
  function keepIcons() {
    sr.querySelectorAll(".icon-wrap").forEach(function (icon, idx) {
      icon.style.border = "none";
      const svg = icon.querySelector("svg");
      if (svg) svg.style.display = "none";
      if (icon.querySelector(".custom-milestone-img")) return;

      const img = document.createElement("img");
      img.className = "custom-milestone-img";
      img.style.cssText = "width:24px;height:24px;object-fit:contain;";
      img.src = idx === 0
        ? "https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Vector.png?v=1776509059"
        : "https://cdn.shopify.com/s/files/1/0034/7901/1441/files/vecteezy_ai-generated-red-gift-box-with-golden-bow-on-transparent_37796385_1.png?v=1776509170";
      icon.appendChild(img);
    });
    sr.querySelectorAll(".steps-wrap").forEach(w => w.style.border = "none");
  }

  // ── 3c. Banner (ek hi function — dono sections ke liye)
  // function replaceBanner() {
  //   const promotionBanner = sr.querySelector(".promotion-banner");
  //   if (!promotionBanner || promotionBanner.querySelector(".custom-brand-banner")) return;
  //   const newBanner = document.createElement("div");
  //   newBanner.className = "custom-brand-banner";
  //   newBanner.style.cssText = "background-color:#9B5E34;text-align:center;color:#ffffff;padding:8px 16px;font-size:13px;font-weight:500;";
  //   newBanner.innerHTML = `
  //     <img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/sale_1_1.png?v=1776495333"
  //       style="height:14px;vertical-align:middle;margin-right:6px;" />
  //     <span> Brand of the year | Trusted by <strong>20L+</strong> Customers Worldwide</span>`;
  //   promotionBanner.parentNode.replaceChild(newBanner, promotionBanner);
  // }

  function replaceBanner() {
  const promotionBanner = sr.querySelector(".promotion-banner");

  // ✅ Stop if original banner not found
  if (!promotionBanner) return;

  // ✅ Stop if custom banner already exists (anywhere in the same parent)
  if (sr.querySelector(".custom-brand-banner")) return;

  const newBanner = document.createElement("div");
  newBanner.className = "custom-brand-banner";
  newBanner.style.cssText = "background-color:#9B5E34;text-align:center;color:#ffffff;padding:8px 16px;font-size:13px;font-weight:500;";

  newBanner.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/sale_1_1.png?v=1776495333"
      style="height:14px;vertical-align:middle;margin-right:6px;" />
    <span>Brand of the year | Trusted by <strong>20L+</strong> Customers Worldwide</span>
  `;

  // ✅ Replace only once
  promotionBanner.replaceWith(newBanner);
}

  // ── 3d. Checkout messages
  function showMessages() {
    const offerBox = sr.querySelector(".offer-box");
    if (!offerBox) return;

    sr.querySelector(".my-checkout-text")?.remove();
    sr.querySelector(".my-offer-text")?.remove();

    const checkoutMessage = document.createElement("div");
    checkoutMessage.className = "my-checkout-text";
    checkoutMessage.innerHTML = `
      <span>Checkout to unlock additional discounts</span>
      <img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/discount_1_2.png?v=1776497527"
        style="height:18px;vertical-align:middle;margin-left:6px;" />`;

    const offerRewardsText = document.createElement("div");
    offerRewardsText.className = "my-offer-text";
    offerRewardsText.innerHTML = `<span>Offer & Rewards</span>`;

    offerBox.parentNode.insertBefore(checkoutMessage, offerBox);
    offerBox.parentNode.insertBefore(offerRewardsText, offerBox);

    checkoutMessage.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const btn = sr.querySelector(".gokwik-checkout, .checkout-button, [data-checkout]");
      if (btn) btn.click();
    });
  }

  // ── 3e. Estimated total → View Details
  function fixEstimatedText() {
    const t = sr.querySelector(".estimated-total");
    if (t && t.innerText !== "View Details") t.innerText = "View Details";
  }

  // ── 3f. Gift text
  function fixGiftText() {
    const el = sr.querySelector(".next-milestone-text");
    if (el && el.innerText === "You have successfully unlocked your rewards!") {
      el.innerText = "Spend ₹300 To Get 1 Gift";
    }
  }

  // ── 3g. Recent product title
  function fixProductTitle() {
    const el = sr.querySelector(".title p, .title");
    if (el && el.innerText === "Try on Sale !") {
      el.innerText = "Products Loved Together !";
    }
  }

  // ── 3h. Price Details popup (guard: sirf ek baar rebuild)
  function buildPriceDetails() {
    const breakdown = sr.querySelector(".order-breakdown");
    if (!breakdown || breakdown.querySelector(".custom-price-text")) return;

    const itemCount = Array.from(sr.querySelectorAll(".item-quantity"))
      .reduce((sum, el) => sum + (parseInt(el.value) || 0), 0);

    const get = (sel) => breakdown.querySelector(sel)?.innerText || '₹0';

    breakdown.innerHTML = `
      <div class="custom-price-text">
        <h3 style="margin:0 0 8px;font-size:16px;font-weight:600;">Price Details</h3>
        <p style="margin:0 0 12px;font-size:12px;color:#666;">Prices are inclusive of all taxes</p>
        <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;">
          <span>Bag Total (${itemCount} ${itemCount === 1 ? 'item' : 'items'})</span>
          <span>${get('.breakdown-row:first-child span:last-child')}</span>
        </div>
        <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;color:#2e7d32;">
          <span>Discount on MRP</span>
          <span>${get('.breakdown-row.discount span:last-child')}</span>
        </div>
        <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;font-weight:500;">
          <span>Sub Total</span>
          <span>${get('.breakdown-row:nth-child(3) span:last-child')}</span>
        </div>
        <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;color:#2e7d32;">
          <span>Total Discount</span>
          <span>${get('.breakdown-row.discount:nth-child(4) span:last-child')}</span>
        </div>
        <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;">
          <span>Convenience Charge</span><span>₹70.00</span>
        </div>
        <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;">
          <span>Shipping Charges</span>
          <span style="color:#2e7d32;">${get('.breakdown-row:nth-child(7) span:last-child')}</span>
        </div>
        <div style="display:flex;justify-content:space-between;margin-top:12px;padding-top:12px;border-top:1px solid #eee;font-size:16px;font-weight:700;">
          <span>You Pay</span>
          <span>${get('.total-row span:last-child')}</span>
        </div>
      </div>`;
  }

  // ── 3i. Add note wrapper
  function wrapNotes() {
    const notes = sr.querySelector(".order-note");
    const viewBtn = sr.querySelector(".view-offers-button");
    if (!notes || !viewBtn || notes.closest(".view-notes-wrapper")) return;

    const wrapper = document.createElement("div");
    wrapper.className = "view-notes-wrapper";
    viewBtn.parentNode.insertBefore(wrapper, viewBtn);
    wrapper.appendChild(viewBtn);
    wrapper.appendChild(notes);
  }

  // ── 3j. Upsell card price+button wrapper
  function wrapPriceAndButton() {
    sr.querySelectorAll(".card").forEach(function (card) {
      if (card.querySelector(".price-btn-wrapper")) return;
      const price = card.querySelector(".price");
      const addBtn = card.querySelector(".add-btn");
      if (!price || !addBtn) return;

      const wrapper = document.createElement("div");
      wrapper.className = "price-btn-wrapper";
      wrapper.style.cssText = "display:flex;align-items:center;justify-content:space-between;margin-top:8px;gap:10px;";
      price.parentNode.insertBefore(wrapper, price);
      wrapper.appendChild(price);
      wrapper.appendChild(addBtn);
      price.style.margin = "0";
      addBtn.style.margin = "0";
    });
  }

  // ── 3k. Cart layout styles inject
  function injectCartStyles() {
    if (sr.querySelector("#custom-cart-styles")) return;

    const style = document.createElement("style");
    style.id = "custom-cart-styles";
    style.textContent = `
      .item.svelte-1s3ixll{display:grid!important;grid-template-columns:80px 1fr!important;gap:0 10px!important;align-items:start!important;padding:12px 0!important}
      .product-main-content.svelte-1s3ixll{display:contents!important}
      .img.svelte-1s3ixll{grid-column:1!important;grid-row:1/5!important;width:80px!important;height:80px!important}
      .img.svelte-1s3ixll img{width:80px!important;height:80px!important;object-fit:cover!important;border-radius:8px!important;display:block!important}
      .details.space-between.svelte-1s3ixll{grid-column:2!important;grid-row:1!important;display:flex!important;flex-direction:column!important;align-items:flex-start!important;gap:0!important;width:100%!important;padding:0!important}
      .item-price.svelte-1s3ixll{grid-column:2!important;grid-row:2!important;display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:center!important;gap:6px!important;margin-top:0!important;width:100%!important}
      .quantity-handler-wrapper.svelte-1s3ixll{grid-column:2!important;grid-row:3!important;display:flex!important;flex-direction:row!important;justify-content:flex-start!important;align-items:center!important;margin-top:6px!important;width:auto!important}
      .sidecart-product-title.svelte-1s3ixll{font-weight:600!important;font-size:13px!important;line-height:1.3!important;white-space:normal!important}
      .compare-at-price.svelte-1s3ixll{font-size:12px!important;color:#999!important}
      .final-price.svelte-1s3ixll{font-size:14px!important;font-weight:700!important}
      .discount-percentage.svelte-1s3ixll{font-size:11px!important;color:green!important}
      strike.compare-at-price.svelte-1s3ixll{order:2}
    `;
    sr.appendChild(style);
  }

  // ── 3l. Cart layout DOM fix
  function layoutFix() {
    sr.querySelectorAll(".item.svelte-1s3ixll").forEach(function (item) {
      const itemPrice = item.querySelector(".item-price");
      const variantList = item.querySelector(".variant-list");
      const qtyWrapper = item.querySelector(".quantity-handler-wrapper");
      if (itemPrice && variantList && !itemPrice.contains(variantList)) itemPrice.appendChild(variantList);
      if (qtyWrapper && itemPrice && itemPrice.contains(qtyWrapper)) itemPrice.after(qtyWrapper);
    });
  }

  // ── RUN ALL on init
  function runAll() {
    fixCartText();
    keepIcons();
    replaceBanner();
    showMessages();
    fixEstimatedText();
    fixGiftText();
    fixProductTitle();
    buildPriceDetails();
    wrapNotes();
    wrapPriceAndButton();
    injectCartStyles();
    layoutFix();
  }

  runAll();

  // ── SINGLE shadowRoot observer (debounced) — sab kuch yahan handle
  new MutationObserver(debounce(runAll, 120)).observe(sr, {
    childList: true,
    subtree: true,
    characterData: true
  });
});


// ─── 4. JUDGEME REVIEW BADGES IN CART ────────────────────────
(function () {
  const STORAGE_KEY = "jdgm_badge_map_v5";

  function loadStoredMap() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function saveMap(map) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map)); } catch (e) {}
  }

  let cachedBadgeMap = loadStoredMap();

  function getStarsFromBadge(prevBadge) {
    return Array.from(prevBadge.querySelectorAll(".jdgm-star")).map(star => {
      if (star.classList.contains("jdgm--on")) return '<span style="color:#f5a623;font-size:15px;">★</span>';
      if (star.classList.contains("jdgm--half")) return '<span style="color:#f5a623;font-size:15px;">✬</span>';
      return '<span style="color:#ddd;font-size:15px;">★</span>';
    }).join("");
  }

  function findTitleNearBadge(badge) {
    let el = badge.parentElement, depth = 0;
    while (el && depth < 8) {
      const t = el.querySelector("h1,h2,h3,h4,.product-title,.card__heading,[class*='title']:not([class*='badge']):not([class*='review'])");
      if (t?.textContent?.trim()) return t.textContent.trim();
      const d = el.getAttribute("data-product-title") || el.getAttribute("data-title") || el.getAttribute("data-name");
      if (d) return d;
      el = el.parentElement; depth++;
    }
    return null;
  }

  function normalize(str) { return str.toLowerCase().replace(/\s+/g, " ").trim(); }

  function buildTitleBadgeMap() {
    const map = loadStoredMap();
    document.querySelectorAll(".jdgm-preview-badge").forEach(function (badge) {
      const prevBadge = badge.querySelector(".jdgm-prev-badge");
      if (!prevBadge) return;
      const count = parseInt(prevBadge.getAttribute("data-number-of-reviews")) || 0;
      const rating = parseFloat(prevBadge.getAttribute("data-average-rating")) || 0;
      const jdgmTitle = prevBadge.getAttribute("data-product-title") || badge.getAttribute("data-product-title");
      const title = jdgmTitle || findTitleNearBadge(badge);
      if (!title) return;
      const key = normalize(title);
      if (count === 0 || rating === 0) { delete map[key]; return; }
      const badgeText = prevBadge.querySelector(".jdgm-prev-badge__text")?.textContent?.trim();
      if (!badgeText || badgeText.toLowerCase().includes("no review")) { delete map[key]; return; }
      map[key] = { stars: getStarsFromBadge(prevBadge), text: badgeText, rating, count };
    });
    cachedBadgeMap = map;
    saveMap(map);
    return map;
  }

  function injectBadges() {
    const sc = document.querySelector("shadow-dom-container");
    if (!sc?.shadowRoot) return;
    const sr = sc.shadowRoot;
    const productTitles = sr.querySelectorAll(".sidecart-product-title");
    if (!productTitles.length) return;
    const badgeMap = Object.keys(cachedBadgeMap).length > 0 ? cachedBadgeMap : buildTitleBadgeMap();
    if (!Object.keys(badgeMap).length) return;

    productTitles.forEach(function (titleEl) {
      if (titleEl.parentElement?.querySelector(".custom-jdgm-review")) return;
      const data = badgeMap[normalize(titleEl.textContent || "")];
      if (!data) return;

      const wrapper = document.createElement("div");
      wrapper.className = "custom-jdgm-review";
      wrapper.innerHTML = `
        <div style="display:flex!important;align-items:center;gap:5px;margin-top:5px;height:auto!important;overflow:visible!important;visibility:visible!important;">
          <span style="display:inline-flex!important;gap:1px;">${data.stars}</span>
          <span class="review-icon">
            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.7635 7.39269C14.0932 7.01572 14.0932 6.45303 13.7635 6.07606L12.995 5.19728C12.8147 4.9911 12.7268 4.71997 12.752 4.44721L12.8589 3.28715C12.9049 2.78765 12.5737 2.33134 12.0846 2.22023L10.9529 1.96318C10.6846 1.90224 10.4533 1.73346 10.3134 1.49657L9.71994 0.491771C9.46416 0.0586931 8.92651 -0.117005 8.46434 0.0814546L7.40051 0.538275C7.14859 0.646454 6.86329 0.646454 6.61137 0.538275L5.54642 0.0809748C5.08474 -0.117279 4.54763 0.0578342 4.29152 0.490112L3.69937 1.48956C3.55891 1.72664 3.32684 1.89524 3.05797 1.95557L1.92987 2.20869C1.43954 2.31871 1.10702 2.77552 1.153 3.27594L1.26013 4.44173C1.28513 4.71379 1.19773 4.98424 1.01823 5.19021L0.246142 6.07622C-0.0824211 6.45326 -0.0819232 7.01506 0.247308 7.39151L1.01697 8.27158C1.19724 8.4777 1.28509 8.74872 1.26003 9.0214L1.15279 10.1885C1.1069 10.6879 1.43803 11.144 1.92709 11.2551L3.05974 11.5124C3.32756 11.5732 3.55858 11.7416 3.69857 11.9778L4.2904 12.9767C4.54699 13.4098 5.08552 13.5847 5.54758 13.3849L6.61044 12.9254C6.86289 12.8162 7.14915 12.8159 7.40186 12.9244L8.46546 13.3811C8.92714 13.5794 9.46425 13.4042 9.72036 12.972L10.3133 11.9712C10.4533 11.7349 10.6843 11.5666 10.9521 11.5057L12.0846 11.2485C12.5737 11.1374 12.9049 10.6811 12.8589 10.1816L12.752 9.02154C12.7268 8.74878 12.8147 8.47766 12.995 8.27147L13.7635 7.39269ZM6.44064 9.17107C6.04991 9.56287 5.41529 9.56289 5.02454 9.17111L3.69111 7.83417C3.41937 7.56172 3.41966 7.12066 3.69175 6.84856C3.96451 6.5758 4.40689 6.57628 4.67906 6.84963L5.0243 7.19634C5.41504 7.58878 6.05031 7.58892 6.44123 7.19666L9.13936 4.48931C9.41164 4.2161 9.85396 4.21572 10.1267 4.48847C10.3988 4.76062 10.3991 5.20177 10.1274 5.47429L6.44064 9.17107Z" fill="#4C6FFE"/>
            </svg>
          </span>
          <span style="font-size:11px;color:#555;white-space:nowrap;">${data.text}</span>
        </div>`;
      titleEl.insertAdjacentElement("afterend", wrapper);
    });
  }

  window.addEventListener("load", function () {
    // Page badges observe karo
    if (document.querySelector(".jdgm-preview-badge")) buildTitleBadgeMap();
    new MutationObserver(debounce(function () {
      if (document.querySelector(".jdgm-preview-badge")) buildTitleBadgeMap();
    }, 200)).observe(document.body, { childList: true, subtree: true });

    // Cart ke liye shadow observer
    waitForShadow(function (sr) {
      if (sr._jdgmObserver) return;
      injectBadges();
      const obs = new MutationObserver(debounce(function () {
        const titles = sr.querySelectorAll(".sidecart-product-title");
        const badges = sr.querySelectorAll(".custom-jdgm-review");
        if (titles.length > 0 && badges.length < titles.length) injectBadges();
      }, 150));
      obs.observe(sr, { childList: true, subtree: true });
      sr._jdgmObserver = obs;
    });

    // Cart button click
    document.addEventListener("click", function (e) {
      if (e.target.closest("[class*='cart'],[id*='cart'],[href*='cart']")) injectBadges();
    }, true);
  });
})();



// //=========== review-button load-more icon=====//

// document.addEventListener('DOMContentLoaded', function () {

//   function injectIcons() {
//     document.querySelectorAll('.jdgm-paginate__load-more').forEach(function(btn) {

//       // 👉 TEXT CHANGE (Load more → View more)
//       btn.childNodes.forEach(function(node) {
//         if (node.nodeType === 3) { // text node
//           node.textContent = 'View More';
//         }
//       });

//       if (btn.querySelector('.custom-arrow-icon')) return;

//       var icon = document.createElement('span');
//       icon.className = 'custom-arrow-icon';

//       icon.innerHTML = `
//         <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
//           <rect x="0.5" y="-0.5" width="19" height="19" rx="9.5"
//             transform="matrix(1 0 0 -1 0.5 19.2014)" stroke="#808080"/>
//           <path d="M7 8.7431L10.5 11.6598L14 8.7431"
//             stroke="#808080" stroke-linecap="round"/>
//         </svg>
//       `;

//       btn.appendChild(icon);
//     });
//   }

//   function updateIconRotation(btn) {
//     var icon = btn.querySelector('.custom-arrow-icon');
//     if (!icon) return;

//     var isExpanded = btn.getAttribute('aria-expanded') === 'true';

//     if (isExpanded) {
//       icon.classList.add('rotate-down');
//       icon.classList.remove('rotate-up');
//     } else {
//       icon.classList.add('rotate-up');
//       icon.classList.remove('rotate-down');
//     }
//   }

//   injectIcons();
//   document.querySelectorAll('.jdgm-paginate__load-more').forEach(updateIconRotation);

//   new MutationObserver(function() {
//     injectIcons();
//     document.querySelectorAll('.jdgm-paginate__load-more').forEach(updateIconRotation);
//   }).observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   document.addEventListener('click', function(e) {
//     var btn = e.target.closest('.jdgm-paginate__load-more');
//     if (!btn) return;
//     updateIconRotation(btn);
//   });

// });



// //=========== judgme-review-comment-count=====//

// (function() {
//   function formatWithCommas(str) {
//     // Remove existing commas, add new ones
//     let num = parseInt(str.replace(/,/g, ''), 10);
//     if (isNaN(num)) return str;
//     return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//   }
  
//   function fixReviewNumbers() {
//     // Fix the badge text element
//     const badge = document.querySelector('.jdgm-prev-badge__text');
//     if (badge && badge.textContent) {
//       let text = badge.textContent;
//       // Find number in parentheses like (2089 reviews)
//       let fixed = text.replace(/\((\d+)\s*reviews?\)/gi, function(match, num) {
//         let formatted = formatWithCommas(num);
//         return '(' + formatted + ' reviews)';
//       });
//       if (fixed !== text) {
//         badge.textContent = fixed;

//       }
//     }
    
//     // Fix the review count element
//     const count = document.getElementById('jdgm-review-count');
//     if (count && count.textContent) {
//       let fixed = formatWithCommas(count.textContent);
//       if (fixed !== count.textContent) {
//         count.textContent = fixed;

//       }
//     }
//   }
  
//   // Run multiple times
//   fixReviewNumbers();
//   setTimeout(fixReviewNumbers, 0);
//   setTimeout(fixReviewNumbers, 0);
//   setTimeout(fixReviewNumbers, 0);
  
//   // Watch for changes
//   new MutationObserver(fixReviewNumbers).observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// })();

// //======== Your Cart text fix change=====//
// (function(){
//     function f(){
//         const s=document.querySelector("shadow-dom-container");
//         if(!s||!s.shadowRoot){setTimeout(f,0);return;}
//         const t=s.shadowRoot.querySelector(".side-cart-header p");
//         if(t&&t.innerText!=="Your Cart")t.innerText="Your Cart";
//     }
//     f();
//     const s=document.querySelector("shadow-dom-container");
//     if(s&&s.shadowRoot)new MutationObserver(()=>f()).observe(s.shadowRoot,{childList:true,subtree:true});
// })();


// //========progress bar icon change=====//
// (function() {
//     function keepIcons() {
//         const s = document.querySelector("shadow-dom-container");
//         if (!s || !s.shadowRoot) return;
//         const sr = s.shadowRoot;
//         sr.querySelectorAll(".icon-wrap").forEach((icon, idx) => {
//             icon.style.border = "none";
//             const svg = icon.querySelector("svg");
//             if (svg) svg.style.display = "none";
//             if (!icon.querySelector(".custom-milestone-img")) {
//                 const img = document.createElement("img");
//                 img.className = "custom-milestone-img";
//                 img.style.cssText = "width: 24px; height: 24px; object-fit: contain;";
//                 img.src = idx === 0 
//                     ? "https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Vector.png?v=1776509059"
//                     : "https://cdn.shopify.com/s/files/1/0034/7901/1441/files/vecteezy_ai-generated-red-gift-box-with-golden-bow-on-transparent_37796385_1.png?v=1776509170";
//                 icon.appendChild(img);
//             }
//         });
//         sr.querySelectorAll(".steps-wrap").forEach(w => w.style.border = "none");
//     }
//     keepIcons();
//     setInterval(keepIcons, 1000);
//     const s = document.querySelector("shadow-dom-container");
//     if (s && s.shadowRoot) new MutationObserver(() => keepIcons()).observe(s.shadowRoot, {childList: true, subtree: true});
// })();


// //========checkout-text change=====//
// (function() {
    
//     function showMessages() {
//         const shadowContainer = document.querySelector("shadow-dom-container");
        
//         if (!shadowContainer || !shadowContainer.shadowRoot) {
//             setTimeout(showMessages, 0);
//             return;
//         }
        
//         const shadowRoot = shadowContainer.shadowRoot;
        
//         const offerBox = shadowRoot.querySelector(".offer-box");
        
//         if (!offerBox) {
//             setTimeout(showMessages, 0);
//             return;
//         }
        
//         // Always check and add messages (remove existing first to avoid duplicates)
//         const existingCheckout = shadowRoot.querySelector(".my-checkout-text");
//         const existingOffer = shadowRoot.querySelector(".my-offer-text");
        
//         if (existingCheckout) existingCheckout.remove();
//         if (existingOffer) existingOffer.remove();
        
//         // Checkout message with image
//         const checkoutMessage = document.createElement("div");
//         checkoutMessage.className = "my-checkout-text";
//         checkoutMessage.innerHTML = `
//             <span>Checkout to unlock additional discounts</span> 
//              <img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/discount_1_2.png?v=1776497527" style="height:18px;vertical-align:middle;margin-left:6px;" />
//         `;
        
//         // Offer & Rewards with image
//         const offerRewardsText = document.createElement("div");
//         offerRewardsText.className = "my-offer-text";
//         offerRewardsText.innerHTML = `
//             <span>Offer & Rewards</span>
//         `;
        
//         // Dono ko offer box ke upar insert karo
//         offerBox.parentNode.insertBefore(checkoutMessage, offerBox);
//         offerBox.parentNode.insertBefore(offerRewardsText, offerBox);
        
//         // Click event for checkout message
//         checkoutMessage.addEventListener("click", function(e) {
//             e.preventDefault();
//             e.stopPropagation();
//             const checkoutBtn = shadowRoot.querySelector(".gokwik-checkout, .checkout-button, [data-checkout]");
//             if (checkoutBtn) checkoutBtn.click();
//         });
        

//     }
    
//     // Banner replace function with image
//     function replaceBanner() {
//         const shadowContainer = document.querySelector("shadow-dom-container");
        
//         if (!shadowContainer || !shadowContainer.shadowRoot) {
//             setTimeout(replaceBanner, 0);
//             return;
//         }
        
//         const shadowRoot = shadowContainer.shadowRoot;
//         const promotionBanner = shadowRoot.querySelector(".promotion-banner");
        
//         if (!promotionBanner || promotionBanner.querySelector(".custom-brand-banner")) return;
        
//         const newBanner = document.createElement("div");
//         newBanner.className = "custom-brand-banner";
//         newBanner.style.cssText = "background-color:#9B5E34;text-align:center;color:#ffffff;padding:8px 16px;font-size:13px;font-weight:500;";
//         newBanner.innerHTML = `
//             <img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/sale_1_1.png?v=1776495333" style="height:14px;vertical-align:middle;margin-right:6px;" />
//             <span> Brand of the year | Trusted by <strong>20L+</strong> Customers Worldwide</span>
//         `;
        
//         promotionBanner.parentNode.replaceChild(newBanner, promotionBanner);

//     }
    
//     // Strong observer
//     function observeAndKeepMessages() {
//         const shadowContainer = document.querySelector("shadow-dom-container");
        
//         if (!shadowContainer || !shadowContainer.shadowRoot) {
//             setTimeout(observeAndKeepMessages, 100);
//             return;
//         }
        
//         const shadowRoot = shadowContainer.shadowRoot;
        
//         const observer = new MutationObserver(function(mutations) {
//             let shouldReAdd = false;
            
//             mutations.forEach(function(mutation) {
//                 if (mutation.removedNodes.length > 0) {
//                     mutation.removedNodes.forEach(function(node) {
//                         if (node && node.className && (node.className === "my-checkout-text" || node.className === "my-offer-text")) {
//                             shouldReAdd = true;
//                         }
//                     });
//                 }
                
//                 if (mutation.target && mutation.target.className === "offer-box") {
//                     shouldReAdd = true;
//                 }
//             });
            
//             if (shouldReAdd) {
//                 setTimeout(function() {
//                     showMessages();
//                 }, 0);
//             }
//         });
        
//         observer.observe(shadowRoot, { 
//             childList: true, 
//             subtree: true,
//             attributes: true
//         });
        
//         showMessages();
//         replaceBanner();
        
//         setInterval(function() {
//             const offerBox = shadowRoot.querySelector(".offer-box");
//             const existingMsg = shadowRoot.querySelector(".my-checkout-text");
//             const existingBanner = shadowRoot.querySelector(".promotion-banner");
            
//             if (offerBox && !existingMsg) {
//                 showMessages();
//             }
//             if (existingBanner && !existingBanner.querySelector(".custom-brand-banner")) {
//                 replaceBanner();
//             }
//         }, 0);
//     }
    
//     // Start
//     if (document.readyState === "loading") {
//         document.addEventListener("DOMContentLoaded", observeAndKeepMessages);
//     } else {
//         observeAndKeepMessages();
//     }
    
// })();


// //========estimated button change=====//
// (function(){
//     function forceViewDetails() {
//         const s = document.querySelector("shadow-dom-container");
//         if (!s || !s.shadowRoot) return false;
        
//         const t = s.shadowRoot.querySelector(".estimated-total");
//         if (t && t.innerText !== "View Details") {
//             t.innerText = "View Details";
//         }
//         return true;
//     }

//     // Initial attempt with retry
//     function tryFix(retries = 20, delay = 100) {
//         if (forceViewDetails()) return;
//         if (retries > 0) {
//             setTimeout(() => tryFix(retries - 1, delay), delay);
//         }
//     }
//     tryFix();

//     // Watch for changes and re-apply
//     const s = document.querySelector("shadow-dom-container");
//     if (s && s.shadowRoot) {
//         const observer = new MutationObserver(() => {
//             forceViewDetails();
//         });
//         observer.observe(s.shadowRoot, {
//             childList: true,
//             subtree: true,
//             characterData: true
//         });
        
//         // Also watch for attribute changes on the element itself
//         const textObserver = new MutationObserver(() => forceViewDetails());
//         const targetEl = s.shadowRoot.querySelector(".estimated-total");
//         if (targetEl) {
//             textObserver.observe(targetEl, {
//                 characterData: true,
//                 subtree: true,
//                 childList: true
//             });
//         }
//     }
// })();



// //========Gift text change=====//
// (function() {
//     // Text replace function
//     function replaceText() {
//         const shadowContainer = document.querySelector("shadow-dom-container");
//         if (!shadowContainer || !shadowContainer.shadowRoot) {
//             setTimeout(replaceText, 100);
//             return;
//         }
//         const shadowRoot = shadowContainer.shadowRoot;
//         const milestoneText = shadowRoot.querySelector(".next-milestone-text");
//         if (milestoneText && milestoneText.innerText === "You have successfully unlocked your rewards!") {
//             milestoneText.innerText = "Spend ₹300 To Get 1 Gift";
//         }
//     }
//     // Banner replace function
//     function replaceBanner() {
//         const shadowContainer = document.querySelector("shadow-dom-container");
//         if (!shadowContainer || !shadowContainer.shadowRoot) {
//             setTimeout(replaceBanner, 0);
//             return;
//         }
//         const shadowRoot = shadowContainer.shadowRoot;
//         const promotionBanner = shadowRoot.querySelector(".promotion-banner");
//         if (!promotionBanner || promotionBanner.querySelector(".custom-brand-banner")) return;
//         const customBanner = shadowRoot.querySelector(".custom-brand-banner");
//           customBanner.remove();

//         const newBanner = document.createElement("div");
//         newBanner.className = "custom-brand-banner";
//         newBanner.style.cssText = "background-color:#9B5E34;text-align:center;color:#ffffff;padding:8px 16px;font-size:13px;font-weight:500;";
//         newBanner.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/sale_1_1.png?v=1776495333" style="height:16px;vertical-align:middle;margin-right:6px;" /> Brand of the year | Trusted by 20L+ Customers Worldwide';
//         promotionBanner.parentNode.replaceChild(newBanner, promotionBanner);
//     }
//     // Initial calls
//     replaceText();
//     replaceBanner();
//     // Observer for permanent changes
//     const shadowContainer = document.querySelector("shadow-dom-container");
//     if (shadowContainer && shadowContainer.shadowRoot) {
//         const observer = new MutationObserver(function() {
//             replaceText();
//             replaceBanner();
//         });
//         observer.observe(shadowContainer.shadowRoot, {
//             childList: true,
//             subtree: true,
//             characterData: true
//         });
//     }
//     // Backup interval
//     setInterval(function() {
//         replaceText();
//         replaceBanner();
//     }, 0);
// })();



// //========recent product text change=====//
// (function() {
//     function replaceText() {
//         const shadowContainer = document.querySelector("shadow-dom-container");
        
//         if (!shadowContainer || !shadowContainer.shadowRoot) {
//             setTimeout(replaceText, 100);
//             return;
//         }
        
//         const shadowRoot = shadowContainer.shadowRoot;
        
        
//         const titleElement = shadowRoot.querySelector(".title p, .title");
        
//         if (titleElement) {
//             if (titleElement.innerText === "Try on Sale !") {
//                 titleElement.innerText = "Products Loved Together !";

//             }
//         } else {
//             setTimeout(replaceText, 100);
//         }
//     }
    
//     replaceText();
    
    
//     const shadowContainer = document.querySelector("shadow-dom-container");
//     if (shadowContainer && shadowContainer.shadowRoot) {
//         new MutationObserver(() => replaceText()).observe(shadowContainer.shadowRoot, {
//             childList: true,
//             subtree: true,
//             characterData: true
//         });
//     }
    
    
//     setInterval(replaceText, 0);
// })();



// //========Price Details pop-up change=====//

// (function() {
//     function changeTextOnly() {
//         const s = document.querySelector("shadow-dom-container");
//         if (!s || !s.shadowRoot) { setTimeout(changeTextOnly, 100); return; }
        
//         const sr = s.shadowRoot;
//         const breakdown = sr.querySelector(".order-breakdown");
//         if (!breakdown) { setTimeout(changeTextOnly, 100); return; }
        
//         if (breakdown.querySelector(".custom-price-text")) return;
        
       
//         const itemCount = Array.from(sr.querySelectorAll(".item-quantity"))
//             .reduce((sum, el) => sum + (parseInt(el.value) || 0), 0);

        
//         const mrpTotal = breakdown.querySelector(".breakdown-row:first-child span:last-child");
//         const discountMrp = breakdown.querySelector(".breakdown-row.discount span:last-child");
//         const cartSubtotal = breakdown.querySelector(".breakdown-row:nth-child(3) span:last-child");
//         const totalDiscount = breakdown.querySelector(".breakdown-row.discount:nth-child(4) span:last-child");
//         const shippingCharge = breakdown.querySelector(".breakdown-row:nth-child(7) span:last-child");
//         const totalSavings = breakdown.querySelector(".breakdown-row.discount:last-child span:last-child");
//         const estimatedTotal = breakdown.querySelector(".total-row span:last-child");
        
//         breakdown.innerHTML = `
//             <div class="custom-price-text">
//                 <h3 style="margin:0 0 8px 0; font-size:16px; font-weight:600;">Price Details</h3>
//                 <p style="margin:0 0 12px 0; font-size:12px; color:#666;">Prices are inclusive of all taxes</p>
                
//                 <div style="display:flex; justify-content:space-between; margin-bottom:10px; font-size:14px;">
//                     <span>Bag Total (<span class="item-count">${itemCount}</span> ${itemCount === 1 ? 'item' : 'items'})</span>
//                     <span class="mrp-value">${mrpTotal ? mrpTotal.innerText : '₹0'}</span>
//                 </div>
                
//                 <div style="display:flex; justify-content:space-between; margin-bottom:10px; font-size:14px; color:#2e7d32;">
//                     <span>Discount on MRP</span>
//                     <span class="discount-mrp-value">${discountMrp ? discountMrp.innerText : '₹0'}</span>
//                 </div>
                
//                 <div style="display:flex; justify-content:space-between; margin-bottom:10px; font-size:14px; font-weight:500;">
//                     <span>Sub Total</span>
//                     <span class="subtotal-value">${cartSubtotal ? cartSubtotal.innerText : '₹0'}</span>
//                 </div>
                
//                 <div style="display:flex; justify-content:space-between; margin-bottom:10px; font-size:14px; color:#2e7d32;">
//                     <span>Total Discount</span>
//                     <span class="total-discount-value">${totalDiscount ? totalDiscount.innerText : '₹0'}</span>
//                 </div>
                
//                 <div style="display:flex; justify-content:space-between; margin-bottom:10px; font-size:14px;">
//                     <span>Convenience Charge</span>
//                     <span>₹70.00</span>
//                 </div>
                
//                 <div style="display:flex; justify-content:space-between; margin-bottom:10px; font-size:14px;">
//                     <span>Shipping Charges</span>
//                     <span style="color:#2e7d32;">${shippingCharge ? shippingCharge.innerText : 'Free Shipping'}</span>
//                 </div>
                
//                 <div style="display:flex; justify-content:space-between; margin-top:12px; padding-top:12px; border-top:1px solid #eee; font-size:16px; font-weight:700;">
//                     <span>You Pay</span>
//                     <span class="youpay-value">${estimatedTotal ? estimatedTotal.innerText : '₹0'}</span>
//                 </div>
//             </div>
//         `;
        
    
//     }
    
//     changeTextOnly();
    
//     const s = document.querySelector("shadow-dom-container");
//     if (s && s.shadowRoot) {
//         new MutationObserver(() => changeTextOnly()).observe(s.shadowRoot, { childList: true, subtree: true });
//     }
// })();


// //========add-note-code =====//

// (function() {
//     function wrapAndPreserveClicks() {
//         const s = document.querySelector("shadow-dom-container");
//         if (!s || !s.shadowRoot) { setTimeout(wrapAndPreserveClicks, 100); return; }
        
//         const sr = s.shadowRoot;
//         const notes = sr.querySelector(".order-note");
//         const viewBtn = sr.querySelector(".view-offers-button");
        
//         if (!notes || !viewBtn) { setTimeout(wrapAndPreserveClicks, 100); return; }
        
        
//         if (notes.closest(".view-notes-wrapper")) return;
        
        
//         const wrapper = document.createElement("div");
//         wrapper.className = "view-notes-wrapper";
        
        
//         const parent = viewBtn.parentNode;
        
        
//         parent.insertBefore(wrapper, viewBtn);
        
        
//         wrapper.appendChild(viewBtn);
//         wrapper.appendChild(notes);
        
  
        
//     }
    
//     wrapAndPreserveClicks();
    
//     const s = document.querySelector("shadow-dom-container");
//     if (s && s.shadowRoot) {
//         new MutationObserver(() => wrapAndPreserveClicks()).observe(s.shadowRoot, { childList: true, subtree: true });
//     }
// })();







// (function() {
//     function wrapPriceAndButton() {
//         const s = document.querySelector("shadow-dom-container");
//         if (!s || !s.shadowRoot) { setTimeout(wrapPriceAndButton, 100); return; }
//         const sr = s.shadowRoot;
        
//         const cards = sr.querySelectorAll(".card");
//         if (cards.length === 0) { setTimeout(wrapPriceAndButton, 100); return; }
//         cards.forEach((card, index) => {
            
//             if (card.querySelector(".price-btn-wrapper")) return;
           
//             const price = card.querySelector(".price");
            
//             const addBtn = card.querySelector(".add-btn");
//             if (!price || !addBtn) return;
           
//             const wrapper = document.createElement("div");
//             wrapper.className = "price-btn-wrapper";
//             wrapper.style.cssText = "display: flex; align-items: center; justify-content: space-between; margin-top: 8px; gap: 10px;";
            
//             price.parentNode.insertBefore(wrapper, price);
//             wrapper.appendChild(price);
//             wrapper.appendChild(addBtn);
            
//             price.style.margin = "0";
//             addBtn.style.margin = "0";

            
//         });
//     }
//     wrapPriceAndButton();
//     const s = document.querySelector("shadow-dom-container");
//     if (s && s.shadowRoot) {
//         new MutationObserver(() => wrapPriceAndButton()).observe(s.shadowRoot, { childList: true, subtree: true });
//     }
//     setInterval(wrapPriceAndButton, 1000);
// })();







// //========judme-review-code =====//


// (function () {

//   const STORAGE_KEY = "jdgm_badge_map_v5";

//   function loadStoredMap() {
//     try {
//       const stored = sessionStorage.getItem(STORAGE_KEY);
//       return stored ? JSON.parse(stored) : {};
//     } catch (e) { return {}; }
//   }

//   function saveMap(map) {
//     try {
//       sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
//     } catch (e) {}
//   }

//   let cachedBadgeMap = loadStoredMap();

//   function getStarsFromBadge(prevBadge) {
//     return Array.from(prevBadge.querySelectorAll(".jdgm-star")).map(star => {
//       if (star.classList.contains("jdgm--on")) {
//         return '<span style="color:#f5a623;font-size:15px;">★</span>';
//       } else if (star.classList.contains("jdgm--half")) {
//   return '<span style="color:#f5a623;font-size:15px;">✬</span>';
// } else {
//         return '<span style="color:#ddd;font-size:15px;">★</span>';
//       }
//     }).join("");
//   }

//   function findTitleNearBadge(badge) {
//     let el = badge.parentElement;
//     let depth = 0;
//     while (el && depth < 8) {
//       const titleEl = el.querySelector(
//         "h1, h2, h3, h4, .product-title, .card__heading, " +
//         "[class*='title']:not([class*='badge']):not([class*='review'])"
//       );
//       if (titleEl?.textContent?.trim()) return titleEl.textContent.trim();

//       const dataTitle = el.getAttribute("data-product-title") ||
//                         el.getAttribute("data-title") ||
//                         el.getAttribute("data-name");
//       if (dataTitle) return dataTitle;

//       el = el.parentElement;
//       depth++;
//     }
//     return null;
//   }

//   function normalize(str) {
//     return str.toLowerCase().replace(/\s+/g, " ").trim();
//   }

//   function buildTitleBadgeMap() {
//     const map = loadStoredMap();

//     document.querySelectorAll(".jdgm-preview-badge").forEach(function (badge) {
//       const prevBadge = badge.querySelector(".jdgm-prev-badge");
//       if (!prevBadge) return;

//       const count = parseInt(prevBadge.getAttribute("data-number-of-reviews")) || 0;
//       const rating = parseFloat(prevBadge.getAttribute("data-average-rating")) || 0;

//       const jdgmTitle = prevBadge.getAttribute("data-product-title") ||
//                         badge.getAttribute("data-product-title");
//       const title = jdgmTitle || findTitleNearBadge(badge);
//       if (!title) return;

//       const key = normalize(title);

//       // ✅ 0 reviews — map se delete
//       if (count === 0 || rating === 0) {
//         delete map[key];
//         return;
//       }

//       const badgeText = prevBadge.querySelector(".jdgm-prev-badge__text")?.textContent?.trim();
//       if (!badgeText || badgeText.toLowerCase().includes("no review")) {
//         delete map[key];
//         return;
//       }

//       // ✅ Reviews hain — map mein add/update karo
//       map[key] = {
//         stars: getStarsFromBadge(prevBadge),
//         text: badgeText,
//         rating: rating,
//         count: count
//       };


      
//     });

//     cachedBadgeMap = map;
//     saveMap(map);

//     return map;
//   }

//   function injectBadges() {
//     const shadowContainer = document.querySelector("shadow-dom-container");
//     if (!shadowContainer?.shadowRoot) return;

//     const shadowRoot = shadowContainer.shadowRoot;
//     const productTitles = shadowRoot.querySelectorAll(".sidecart-product-title");
//     if (!productTitles.length) return;

//     const badgeMap = Object.keys(cachedBadgeMap).length > 0
//       ? cachedBadgeMap
//       : buildTitleBadgeMap();

//     if (!badgeMap || Object.keys(badgeMap).length === 0) return;

//     productTitles.forEach(function (titleEl) {
//       if (titleEl.parentElement?.querySelector(".custom-jdgm-review")) return;

//       const cartTitle = normalize(titleEl.textContent || "");

//       // ✅ Sirf exact match — koi partial nahi
//       const data = badgeMap[cartTitle];

//       if (!data) {

//         return;
//       }

//       const wrapper = document.createElement("div");
//       wrapper.className = "custom-jdgm-review";
//       wrapper.innerHTML = `
//         <div style="display:flex!important;align-items:center;gap:5px;margin-top:5px;height:auto!important;overflow:visible!important;visibility:visible!important;">
//           <span style="display:inline-flex!important;gap:1px;">${data.stars}</span>
//           <span class="review-icon">
//             <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M13.7635 7.39269C14.0932 7.01572 14.0932 6.45303 13.7635 6.07606L12.995 5.19728C12.8147 4.9911 12.7268 4.71997 12.752 4.44721L12.8589 3.28715C12.9049 2.78765 12.5737 2.33134 12.0846 2.22023L10.9529 1.96318C10.6846 1.90224 10.4533 1.73346 10.3134 1.49657L9.71994 0.491771C9.46416 0.0586931 8.92651 -0.117005 8.46434 0.0814546L7.40051 0.538275C7.14859 0.646454 6.86329 0.646454 6.61137 0.538275L5.54642 0.0809748C5.08474 -0.117279 4.54763 0.0578342 4.29152 0.490112L3.69937 1.48956C3.55891 1.72664 3.32684 1.89524 3.05797 1.95557L1.92987 2.20869C1.43954 2.31871 1.10702 2.77552 1.153 3.27594L1.26013 4.44173C1.28513 4.71379 1.19773 4.98424 1.01823 5.19021L0.246142 6.07622C-0.0824211 6.45326 -0.0819232 7.01506 0.247308 7.39151L1.01697 8.27158C1.19724 8.4777 1.28509 8.74872 1.26003 9.0214L1.15279 10.1885C1.1069 10.6879 1.43803 11.144 1.92709 11.2551L3.05974 11.5124C3.32756 11.5732 3.55858 11.7416 3.69857 11.9778L4.2904 12.9767C4.54699 13.4098 5.08552 13.5847 5.54758 13.3849L6.61044 12.9254C6.86289 12.8162 7.14915 12.8159 7.40186 12.9244L8.46546 13.3811C8.92714 13.5794 9.46425 13.4042 9.72036 12.972L10.3133 11.9712C10.4533 11.7349 10.6843 11.5666 10.9521 11.5057L12.0846 11.2485C12.5737 11.1374 12.9049 10.6811 12.8589 10.1816L12.752 9.02154C12.7268 8.74878 12.8147 8.47766 12.995 8.27147L13.7635 7.39269ZM6.44064 9.17107C6.04991 9.56287 5.41529 9.56289 5.02454 9.17111L3.69111 7.83417C3.41937 7.56172 3.41966 7.12066 3.69175 6.84856C3.96451 6.5758 4.40689 6.57628 4.67906 6.84963L5.0243 7.19634C5.41504 7.58878 6.05031 7.58892 6.44123 7.19666L9.13936 4.48931C9.41164 4.2161 9.85396 4.21572 10.1267 4.48847C10.3988 4.76062 10.3991 5.20177 10.1274 5.47429L6.44064 9.17107Z" fill="#4C6FFE"/>
//             </svg>
//           </span>
//           <span style="font-size:11px;color:#555;white-space:nowrap;">${data.text}</span>
//         </div>
//       `;
//       titleEl.insertAdjacentElement("afterend", wrapper);

//     });
//   }

//   function setupCartObserver() {
//     const shadowContainer = document.querySelector("shadow-dom-container");
//     if (!shadowContainer) { setTimeout(setupCartObserver, 500); return; }

//     const shadowRoot = shadowContainer.shadowRoot;
//     if (!shadowRoot) { setTimeout(setupCartObserver, 500); return; }

//     if (shadowRoot._jdgmObserver) return;

//     const observer = new MutationObserver(function () {
//       const titles = shadowRoot.querySelectorAll(".sidecart-product-title");
//       const badges = shadowRoot.querySelectorAll(".custom-jdgm-review");
//       if (titles.length > 0 && badges.length < titles.length) {
//         injectBadges();
//       }
//     });

//     observer.observe(shadowRoot, { childList: true, subtree: true });
//     shadowRoot._jdgmObserver = observer;

//     injectBadges();
//   }

//   function prebuildMapWithRetry(attempt = 0) {
//     const result = buildTitleBadgeMap();
//     if (Object.keys(result).length === 0 && attempt < 5) {
//       setTimeout(() => prebuildMapWithRetry(attempt + 1), 1500);
//     }
//   }

//   function watchCartButton() {
//     document.addEventListener("click", function (e) {
//       const isCartBtn = e.target.closest("[class*='cart'], [id*='cart'], [href*='cart']");
//       if (isCartBtn) {
//         setTimeout(injectBadges, 800);
//         setTimeout(injectBadges, 1500);
//       }
//     }, true);
//   }

//   window.addEventListener("load", function () {
//     setTimeout(prebuildMapWithRetry, 1000);
//     setTimeout(setupCartObserver, 2000);
//     watchCartButton();
//   });

// })();


// //========wrap-div-product =====//
// function injectCartStyles() {
//   const shadowContainer = document.querySelector("shadow-dom-container");
//   if (!shadowContainer) { setTimeout(injectCartStyles, 500); return; }

//   const shadowRoot = shadowContainer.shadowRoot;
//   if (!shadowRoot) { setTimeout(injectCartStyles, 500); return; }

//   shadowRoot.querySelector("#custom-cart-styles")?.remove();

//   const style = document.createElement("style");
//   style.id = "custom-cart-styles";
//   style.textContent = `

//     .item.svelte-1s3ixll {
//       display: grid !important;
//       grid-template-columns: 80px 1fr !important;
//       gap: 0 10px !important;
//       align-items: start !important;
//       padding: 12px 0 !important;
//     }

//     .product-main-content.svelte-1s3ixll {
//       display: contents !important;
//     }

//     .img.svelte-1s3ixll {
//       grid-column: 1 !important;
//       grid-row: 1 / 5 !important;
//       width: 80px !important;
//       height: 80px !important;
//     }

//     .img.svelte-1s3ixll img {
//       width: 80px !important;
//       height: 80px !important;
//       object-fit: cover !important;
//       border-radius: 8px !important;
//       display: block !important;
//     }

//     /* Title + Review + Variant — col 2, row 1 */
//     .details.space-between.svelte-1s3ixll {
//       grid-column: 2 !important;
//       grid-row: 1 !important;
//       display: flex !important;
//       flex-direction: column !important;
//       align-items: flex-start !important;
//       gap: 0 !important;
//       width: 100% !important;
//       padding: 0px 0px !important;
//     }
// .product-tile-wrapper .custom-jdgm-review div:first-child {
//     margin-top: 0 !important;
// }
//     /* ✅ Price row — col 2, row 2 */
//     .item-price.svelte-1s3ixll {
//       grid-column: 2 !important;
//       grid-row: 2 !important;
//       display: flex !important;
//       flex-direction: row !important;
//       flex-wrap: nowrap !important;
//       align-items: center !important;
//       gap: 6px !important;
//       margin-top:0 !important;
//       width: 100% !important;
//     }

//     /* ✅ Variant — details ke andar, price ke upar */
//     .variant-list.svelte-1s3ixll {
//       display: inline-flex !important;
//       align-items: center !important;
//     }

//     .variant-selector.svelte-1s3ixll select {
//       font-size: 11px !important;
//       padding: 2px 4px !important;
//       height: auto !important;
//     }

//     /* ✅ Qty — col 2, row 3 — ALAG ROW */
//     .quantity-handler-wrapper.svelte-1s3ixll {
//       grid-column: 2 !important;
//       grid-row: 3 !important;
//       display: flex !important;
//       flex-direction: row !important;
//       justify-content: flex-start !important;
//       align-items: center !important;
//       margin-top: 6px !important;
//       width: auto !important;
//     }

//     .sidecart-product-title.svelte-1s3ixll {
//       font-weight: 600 !important;
//       font-size: 13px !important;
//       line-height: 1.3 !important;
//       white-space: normal !important;
//     }

//     .compare-at-price.svelte-1s3ixll {
//       font-size: 12px !important;
//       color: #999 !important;
//     }

//     .final-price.svelte-1s3ixll {
//       font-size: 14px !important;
//       font-weight: 700 !important;
//     }

//     .discount-percentage.svelte-1s3ixll {
//       font-size: 11px !important;
//       color: green !important;
//     }
//       .item.svelte-1s3ixll .details.svelte-1s3ixll {
//     padding: 0 !important;
// }
//     strike.compare-at-price.svelte-1s3ixll {
//     order: 2;
// }
    
//   `;

//   shadowRoot.appendChild(style);

//   // ✅ Variant ko details mein rakho (price se bahar)
//   // Qty ko item-price se bahar nikalo agar andar chali gayi ho
//   shadowRoot.querySelectorAll(".item.svelte-1s3ixll").forEach(function(item) {
//     const itemPrice = item.querySelector(".item-price");
//     const variantList = item.querySelector(".variant-list");
//     const qtyWrapper = item.querySelector(".quantity-handler-wrapper");

//     // ✅ Variant — price ke saath rakho
//     if (itemPrice && variantList && !itemPrice.contains(variantList)) {
//       itemPrice.appendChild(variantList);
//     }

//     // ✅ Qty — item-price ke baad, item ka direct child hona chahiye
//     if (qtyWrapper && itemPrice && itemPrice.contains(qtyWrapper)) {
//       itemPrice.after(qtyWrapper);
//     }
//   });


// }

// function setupObserver() {
//   const shadowContainer = document.querySelector("shadow-dom-container");
//   if (!shadowContainer) { setTimeout(setupObserver, 0); return; }

//   const shadowRoot = shadowContainer.shadowRoot;
//   if (!shadowRoot) { setTimeout(setupObserver, 0); return; }

//   if (shadowRoot._layoutObserver) return;

//   const observer = new MutationObserver(function() {
//     shadowRoot.querySelectorAll(".item.svelte-1s3ixll").forEach(function(item) {
//       const itemPrice = item.querySelector(".item-price");
//       const variantList = item.querySelector(".variant-list");
//       const qtyWrapper = item.querySelector(".quantity-handler-wrapper");

//       if (itemPrice && variantList && !itemPrice.contains(variantList)) {
//         itemPrice.appendChild(variantList);
//       }
//       if (qtyWrapper && itemPrice && itemPrice.contains(qtyWrapper)) {
//         itemPrice.after(qtyWrapper);
//       }
//     });
//   });

//   observer.observe(shadowRoot, { childList: true, subtree: true });
//   shadowRoot._layoutObserver = observer;
// }

// window.addEventListener("load", function() {
//   setTimeout(injectCartStyles, 0);
//   setTimeout(setupObserver, 0);
// });

// setTimeout(injectCartStyles, 0);
// setTimeout(setupObserver, 0);







// // (function () {

// //   const STORAGE_KEY = "jdgm_badge_map_v6";

// //   function loadStoredMap() {
// //     try {
// //       const stored = sessionStorage.getItem(STORAGE_KEY);
// //       return stored ? JSON.parse(stored) : {};
// //     } catch (e) { return {}; }
// //   }

// //   function saveMap(map) {
// //     try {
// //       sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
// //     } catch (e) {}
// //   }

// //   let cachedBadgeMap = loadStoredMap();

// //   function getStarsFromBadge(prevBadge) {
// //     return Array.from(prevBadge.querySelectorAll(".jdgm-star")).map(star => {
// //       if (star.classList.contains("jdgm--on")) {
// //         return '<span style="color:#f5a623;font-size:15px;">★</span>';
// //       } else if (star.classList.contains("jdgm--half")) {
// //   return '<span style="color:#f5a623;font-size:15px;">✬</span>';
// // } 
// //     }).join("");
// //   }

// //   function findTitleNearBadge(badge) {
// //     let el = badge.parentElement;
// //     let depth = 0;
// //     while (el && depth < 8) {
// //       const titleEl = el.querySelector(
// //         "h1, h2, h3, h4, .product-title, .card__heading, " +
// //         "[class*='title']:not([class*='badge']):not([class*='review'])"
// //       );
// //       if (titleEl?.textContent?.trim()) return titleEl.textContent.trim();

// //       const dataTitle = el.getAttribute("data-product-title") ||
// //                         el.getAttribute("data-title") ||
// //                         el.getAttribute("data-name");
// //       if (dataTitle) return dataTitle;

// //       el = el.parentElement;
// //       depth++;
// //     }
// //     return null;
// //   }

// //   function normalize(str) {
// //     return str.toLowerCase().replace(/\s+/g, " ").trim();
// //   }

// //   function buildTitleBadgeMap() {
// //     const map = loadStoredMap();

// //     document.querySelectorAll(".jdgm-preview-badge").forEach(function (badge) {
// //       const prevBadge = badge.querySelector(".jdgm-prev-badge");
// //       if (!prevBadge) return;

// //       const count = parseInt(prevBadge.getAttribute("data-number-of-reviews")) || 0;
// //       const rating = parseFloat(prevBadge.getAttribute("data-average-rating")) || 0;

// //       const jdgmTitle = prevBadge.getAttribute("data-product-title") ||
// //                         badge.getAttribute("data-product-title");
// //       const title = jdgmTitle || findTitleNearBadge(badge);
// //       if (!title) return;

// //       const key = normalize(title);

// //       if (count === 0 || rating === 0) {
// //         delete map[key];
// //         return;
// //       }

// //       const badgeText = prevBadge.querySelector(".jdgm-prev-badge__text")?.textContent?.trim();
// //       if (!badgeText || badgeText.toLowerCase().includes("no review")) {
// //         delete map[key];
// //         return;
// //       }

// //       map[key] = {
// //         stars: getStarsFromBadge(prevBadge),
// //         text: badgeText,
// //         rating: rating,
// //         count: count
// //       };


// //     });

// //     cachedBadgeMap = map;
// //     saveMap(map);

// //     return map;
// //   }

// //   // ✅ Common badge HTML
// //   function buildBadgeHTML(data) {
// //     return `
// //       <div style="display:flex!important;align-items:center;gap:5px;margin-top:5px;height:auto!important;overflow:visible!important;visibility:visible!important;">
// //         <span style="display:inline-flex!important;gap:1px;">${data.stars}</span>
// //         <span class="review-icon">
// //           <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
// //             <path d="M13.7635 7.39269C14.0932 7.01572 14.0932 6.45303 13.7635 6.07606L12.995 5.19728C12.8147 4.9911 12.7268 4.71997 12.752 4.44721L12.8589 3.28715C12.9049 2.78765 12.5737 2.33134 12.0846 2.22023L10.9529 1.96318C10.6846 1.90224 10.4533 1.73346 10.3134 1.49657L9.71994 0.491771C9.46416 0.0586931 8.92651 -0.117005 8.46434 0.0814546L7.40051 0.538275C7.14859 0.646454 6.86329 0.646454 6.61137 0.538275L5.54642 0.0809748C5.08474 -0.117279 4.54763 0.0578342 4.29152 0.490112L3.69937 1.48956C3.55891 1.72664 3.32684 1.89524 3.05797 1.95557L1.92987 2.20869C1.43954 2.31871 1.10702 2.77552 1.153 3.27594L1.26013 4.44173C1.28513 4.71379 1.19773 4.98424 1.01823 5.19021L0.246142 6.07622C-0.0824211 6.45326 -0.0819232 7.01506 0.247308 7.39151L1.01697 8.27158C1.19724 8.4777 1.28509 8.74872 1.26003 9.0214L1.15279 10.1885C1.1069 10.6879 1.43803 11.144 1.92709 11.2551L3.05974 11.5124C3.32756 11.5732 3.55858 11.7416 3.69857 11.9778L4.2904 12.9767C4.54699 13.4098 5.08552 13.5847 5.54758 13.3849L6.61044 12.9254C6.86289 12.8162 7.14915 12.8159 7.40186 12.9244L8.46546 13.3811C8.92714 13.5794 9.46425 13.4042 9.72036 12.972L10.3133 11.9712C10.4533 11.7349 10.6843 11.5666 10.9521 11.5057L12.0846 11.2485C12.5737 11.1374 12.9049 10.6811 12.8589 10.1816L12.752 9.02154C12.7268 8.74878 12.8147 8.47766 12.995 8.27147L13.7635 7.39269ZM6.44064 9.17107C6.04991 9.56287 5.41529 9.56289 5.02454 9.17111L3.69111 7.83417C3.41937 7.56172 3.41966 7.12066 3.69175 6.84856C3.96451 6.5758 4.40689 6.57628 4.67906 6.84963L5.0243 7.19634C5.41504 7.58878 6.05031 7.58892 6.44123 7.19666L9.13936 4.48931C9.41164 4.2161 9.85396 4.21572 10.1267 4.48847C10.3988 4.76062 10.3991 5.20177 10.1274 5.47429L6.44064 9.17107Z" fill="#4C6FFE"/>
// //           </svg>
// //         </span>
// //         <span style="font-size:11px;color:#555;white-space:nowrap;">${data.text}</span>
// //       </div>
// //     `;
// //   }

// //   // ✅ Cart items inject — .sidecart-product-title
// //   function injectCartBadges(shadowRoot, badgeMap) {
// //     const productTitles = shadowRoot.querySelectorAll(".sidecart-product-title");
// //     productTitles.forEach(function (titleEl) {
// //       if (titleEl.parentElement?.querySelector(".custom-jdgm-review")) return;

// //       const cartTitle = normalize(titleEl.textContent || "");
// //       const data = badgeMap[cartTitle];

// //       if (!data) {

// //         return;
// //       }

// //       const wrapper = document.createElement("div");
// //       wrapper.className = "custom-jdgm-review";
// //       wrapper.innerHTML = buildBadgeHTML(data);
// //       titleEl.insertAdjacentElement("afterend", wrapper);

// //     });
// //   }

// //   // ✅ Upsell "Products Loved Together" inject — .product-name
// //   function injectUpsellBadges(shadowRoot, badgeMap) {
// //     const upsellTitles = shadowRoot.querySelectorAll(".product-name");
// //     upsellTitles.forEach(function (titleEl) {
// //       if (titleEl.parentElement?.querySelector(".custom-jdgm-review-upsell")) return;

// //       const upsellTitle = normalize(titleEl.textContent || "");
// //       const data = badgeMap[upsellTitle];

// //       if (!data) {

// //         return;
// //       }

// //       const wrapper = document.createElement("div");
// //       wrapper.className = "custom-jdgm-review-upsell";
// //       wrapper.innerHTML = buildBadgeHTML(data);
// //       titleEl.insertAdjacentElement("afterend", wrapper);

// //     });
// //   }

// //   function injectBadges() {
// //     const shadowContainer = document.querySelector("shadow-dom-container");
// //     if (!shadowContainer?.shadowRoot) return;

// //     const shadowRoot = shadowContainer.shadowRoot;

// //     const badgeMap = Object.keys(cachedBadgeMap).length > 0
// //       ? cachedBadgeMap
// //       : buildTitleBadgeMap();

// //     if (!badgeMap || Object.keys(badgeMap).length === 0) return;

// //     injectCartBadges(shadowRoot, badgeMap);
// //     injectUpsellBadges(shadowRoot, badgeMap);
// //   }

// //   function setupCartObserver() {
// //     const shadowContainer = document.querySelector("shadow-dom-container");
// //     if (!shadowContainer) { setTimeout(setupCartObserver, 500); return; }

// //     const shadowRoot = shadowContainer.shadowRoot;
// //     if (!shadowRoot) { setTimeout(setupCartObserver, 500); return; }

// //     if (shadowRoot._jdgmObserver) return;

// //     const observer = new MutationObserver(function () {
// //       const titles = shadowRoot.querySelectorAll(".sidecart-product-title, .product-name");
// //       const badges = shadowRoot.querySelectorAll(".custom-jdgm-review, .custom-jdgm-review-upsell");
// //       if (titles.length > 0 && badges.length < titles.length) {
// //         injectBadges();
// //       }
// //     });

// //     observer.observe(shadowRoot, { childList: true, subtree: true });
// //     shadowRoot._jdgmObserver = observer;

// //     injectBadges();
// //   }

// //   function prebuildMapWithRetry(attempt = 0) {
// //     const result = buildTitleBadgeMap();
// //     if (Object.keys(result).length === 0 && attempt < 5) {
// //       setTimeout(() => prebuildMapWithRetry(attempt + 1), 1500);
// //     }
// //   }

// //   function watchCartButton() {
// //     document.addEventListener("click", function (e) {
// //       const isCartBtn = e.target.closest("[class*='cart'], [id*='cart'], [href*='cart']");
// //       if (isCartBtn) {
// //         setTimeout(injectBadges, 800);
// //         setTimeout(injectBadges, 1500);
// //       }
// //     }, true);
// //   }

// //   window.addEventListener("load", function () {
// //     setTimeout(prebuildMapWithRetry, 1000);
// //     setTimeout(setupCartObserver, 2000);
// //     watchCartButton();
// //   });

// // })();